module.exports = __webpack_public_path__ + "static/media/KW13_AS2.02563a11.JPG";